import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IAccessChangeStudent } from 'src/app/core/models/access';
import { IEmergencyContact, IMedicalInfo, IStudent } from 'src/app/core/models/user';
import { AttendanceFilter, IAttendanceRecord } from '../../models/academic';

export const StudentActions = createActionGroup({
    source: 'Student',
    events: {
        'Load Students': emptyProps(),
        'Load Students Success': props<{ students: IStudent[] }>(),
        'Load Students Failure': props<{ error: any }>(),
        'Load Students For Accesschange': props<{ studentIds: string[] }>(),
        'Load Students For Accesschange Success': props<{ students: IAccessChangeStudent[] }>(),
        'Load Students For Accesschange Failure': props<{ error: any }>(),
        'Add Student': props<{ student: IStudent }>(),
        'Update Student Success': props<{ student: IStudent }>(),
        'Update Student Failure': props<{ error: any }>(),
        'Update Emergency Contact': props<{ contact: IEmergencyContact }>(),
        'Update Medical Info': props<{ medicalInfo: IMedicalInfo }>(),
        'Update Personal Info': props<{ preferredName: string }>(),
        'Update Student Picture': props<{ studentid: string, pictureFile: File | null, pictureId: string | null, pictureUrl: string }>(),
        'Delete Student': emptyProps(),
        'Select Student': props<{ id: string }>(),
        'Set Attendance Filters': props<{ filters: AttendanceFilter }>(),
        'Reset Attendance Filters': emptyProps(),
        'Load Student Attendance': props<{ studentId: string }>(),
        'Load Student Attendance Success': props<{ studentId: string, attendance: IAttendanceRecord[] }>(),
        'Load Student Attendance Failure': props<{ studentId: string, error: any }>(),
    }
});
